export const emergencyContact = (emergencyContacts: any[] = []) => {
  const contacts = (emergencyContacts || []).filter(contact => {
    if (!contact || typeof contact !== 'object') return false;

    const { name, relationship, phone, address } = contact;
    return [name, relationship, phone, address].some(field => {
      return field && String(field).trim() !== '';
    });
  });

  const finalContacts = contacts.length > 0 ? contacts : Array.from({ length: 3 }, () => ({}));

  return [
    { text: 'Emergency Contact', style: 'h1' },

    ...finalContacts.map(contact => ({
      table: {
        widths: ['35%', '*'],
        body: [
          [
            { text: 'Contact Name:', bold: true, fontSize: 11 },
            { text: contact?.name || '', fontSize: 11 }
          ],
          [
            { text: 'Relation:', bold: true, fontSize: 11 },
            { text: contact?.relation || '', fontSize: 11 }
          ],
          [
            { text: 'Phone Number:', bold: true, fontSize: 11 },
            { text: contact?.phone || '', fontSize: 11 }
          ],
          [
            { text: 'Address:', bold: true, fontSize: 11 },
            { text: contact?.address || '', fontSize: 11 }
          ],
          [
            { text: '', colSpan: 2, margin: [0, 8, 0, 8], border: [false, false, false, false] },
            {}
          ]
        ]
      },
      margin: [0, 5, 0, 0]
    })),

    { text: '', pageBreak: 'before' }
  ];
};